import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Verify2FABodyDto } from "api/Api";
import { useGetApiClient } from "api/get-api-client";

export const useApiUserAuth2faVerify = () => {
  const apiClient = useGetApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (data: Verify2FABodyDto) => {
      await apiClient.auth.verify2Fa(data);
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["auth-2fa"] });
    },
  });
};
